<template>
  <div class="primaryFont flex flex-row gap-4">
    <!-- Left Panel (Cards) -->
    <div class="leftPanel">
      <div class="flex flex-column gap-3 mt-5">
        <CustomCardTab
          v-if="intervinienteStore.intervinientesList.length"
          v-for="interviniente in intervinienteStore.intervinientesList"
          :key="interviniente.PersonalIntervinienteID"
          :status="interviniente.Jerarquia"
          :isSelected="intervinienteStore.isSelected(interviniente.PersonalIntervinienteID)"
          :disabled="
            intervinienteStore.isCreate || intervinienteStore.isLoading || intervinienteStore.isEdit
          "
          @click="handleSelect(interviniente)"
        >
          <template #title>
            <span class="cardTitle">
              {{ interviniente.Nombreyapellido }}
            </span>
          </template>

          <template #content>
            <span class="cardText">
              {{ interviniente.Dependencia }}
            </span>
          </template>
        </CustomCardTab>
        <!-- Card simbólica para modo create -->
        <CustomCardTab
          v-if="intervinienteStore.isCreate && !intervinienteStore.isLoading"
          :key="'create-preview'"
          :status="intervinienteStore.form.jerarquia?.nombre || 'Sin jerarquía'"
          :isSelected="true"
          :isPreview="true"
          @click="() => {}"
        >
          <template #title>
            <div>
              {{
                intervinienteStore.form.nombreyapellido
                  ? intervinienteStore.form.nombreyapellido
                  : "Sin nombre"
              }}
            </div>
          </template>

          <template #content>
            <div>{{ intervinienteStore.form.dependencia?.nombre || "Sin dependencia" }}</div>
          </template>
        </CustomCardTab>
        <Button
          class="plusButton"
          label="Nuevo Personal Interviniente"
          icon="pi pi-plus"
          iconPos="left"
          @click="handleCreate"
          :disabled="
            intervinienteStore.isCreate || intervinienteStore.isLoading || intervinienteStore.isEdit
          "
        />
      </div>
    </div>
    <!-- Right Panel (Inputs) -->
    <div class="rightPanel ml-3 secondaryFont">
      <div>
        <div
          v-if="
            intervinienteStore.intervinientesList.length &&
            !intervinienteStore.selectedId &&
            !intervinienteStore.isCreate
          "
        >
          <p class="informativeText secondaryFont">Seleccione un Interviniente</p>
        </div>

        <div v-if="!intervinienteStore.intervinientesList.length && !intervinienteStore.isCreate">
          <p class="informativeText secondaryFont">
            No hay persona interviniente en esta actuacion. Cree una nueva persona interviniente
          </p>
        </div>

        <div v-else class="mt-5 form">
          <div>
            <h3>Agregar personal interviniente</h3>
          </div>
          <div class="inputs" style="display: flex; gap: 1em">
            <div>
              <label class="labelInput" for="nombre"
                >Nombre y apellido <span class="required">*</span></label
              >
              <InputText
                class="mt-2 mb-3 input"
                id="nombre"
                type="text"
                v-model="intervinienteStore.form.nombreyapellido"
                placeholder="Ingresar Nombre y apellido"
                :disabled="intervinienteStore.isView"
              />
            </div>

            <div>
              <label class="labelInput" for="jerarquia"
                >Jerarquía <span class="required">*</span></label
              >
              <Dropdown
                v-model="intervinienteStore.form.jerarquia"
                :options="jerarquias"
                optionLabel="nombre"
                placeholder="Seleccione jerarquía"
                class="mt-2 mb-3 input"
                :disabled="intervinienteStore.isView"
              />
            </div>

            <div>
              <label class="labelInput" for="jerarquia"
                >Dependencia <span class="required">*</span></label
              >
              <Dropdown
                v-model="intervinienteStore.form.dependencia"
                :options="dependenciaList"
                optionLabel="nombre"
                placeholder="Seleccione dependencia"
                class="mt-2 input"
                :disabled="intervinienteStore.isView"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, onBeforeUnmount, watch } from "vue";
import { useRouterCompat, useStoreCompat } from "@/composables";
import { usePersonalIntervinienteStore } from "@/store/Pinia/usePersonalIntervinienteStore.js";
import CustomCardTab from "@/components/CustomCardTab.vue";

const props = defineProps({
  blockNavigationToAnotherTab: {
    type: Function,
    default: () => {},
  },
  removeTheBlockNavigationToAnotherTab: {
    type: Function,
    default: () => {},
  },
});

const store = useStoreCompat();
const { route } = useRouterCompat();
const intervinienteStore = usePersonalIntervinienteStore();

onMounted(async () => {
  if (!dependencias.value || !dependencias.value.length) {
    store.dispatch("siis/setDependencias");
  }
});

const handleSelect = (interviniente) => {
  if (!intervinienteStore.isCreate) {
    intervinienteStore.select(interviniente);
    intervinienteStore.isEdit = false;
  }
};

const handleCreate = () => {
  if (route?.matched?.[0]?.path !== "/newActuacion") {
    props.blockNavigationToAnotherTab?.();
  }
  intervinienteStore.startCreate();
};

const jerarquias = computed(() => store.state.siis.jerarquia);

const dependencias = computed(() => store.getters["siis/getDependecias"]);

const dependenciaList = computed(() => {
  return (dependencias.value ?? []).map((item) => ({
    id: item.id,
    nombre: item.dependencia,
  }));
});

async function syncValid() {
  try {
    intervinienteStore.validateForm();
    const ok = intervinienteStore.isFormValid;
  } catch (e) {
    console.error(e);
  }
}

watch(
  () => intervinienteStore.form,
  () => {
    syncValid();
  },
  { deep: true }
);
</script>

<style scoped>
.customCard {
  border-radius: 8px;
  border-left: 6px solid #d97706;
  background-color: #eeeeee;
  box-shadow: 0px 4px 4px 0px #00000040;
  max-width: 448px;
  max-height: 104px;
  display: flex;
  justify-content: start;
  align-items: center;
}

.cardTitle {
  font-weight: 700;
  font-style: bold;
  font-size: 20px;
  color: black;
}

.cardText {
  font-weight: 700;
  font-style: bold;
  font-size: 16px;
  color: black;
}

.plusButton {
  background-color: #0b5195;
  border-radius: 6px;
  border: none;
  font-weight: 400;
  font-size: 16px;
}

.plusButton:focus {
  background-color: #0b5195;
  border: none;
}
.plusButton:hover {
  background-color: #0b519580;
  border-radius: 6px;
}

.required {
  color: red;
}

.leftPanel {
  max-width: 448px;
  flex: 1;
}

.rightPanel {
  flex: 2;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 1em;
  background: #eaeaea80;
  padding: 0 10px;
  border-radius: 8px;
}

.labelInput {
  color: #0b5195;
  font-size: 16px;
  font-weight: 400;
}

.input {
  border: 1px solid #0b5195;
  border-radius: 6px;
  width: 100%; /* importante */
  color: #9ca3af;
}

.input:focus {
  border: none !important;
}

.informativeText {
  text-align: center;
  font-size: 28px;
  color: #0b5195;
  font-weight: 500;
}

.plusButton.p-button.p-component {
  display: inline-block !important;
}
</style>
